import { render, staticRenderFns } from "./ExpressModal.vue?vue&type=template&id=5bdce312&scoped=true"
import script from "./ExpressModal.vue?vue&type=script&lang=js"
export * from "./ExpressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdce312",
  null
  
)

export default component.exports